import React, { useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DndTable } from "@components/DND";
import { Awesome } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function SchemeListScreen() {
    const { t } = useTranslation();
    const { apiData, setApiData } = useAppApi(url_reverse("api:schema:list"));
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const header = (
        <>
            <Link to={url_reverse("admin:event:list")}>{t("Настройки")}</Link>
            <span> – </span>
            {t("Управление шаблонами ивентов")}
        </>
    );
    const headerTools = (
        <>
            <Button
                onClick={() => navigate(url_reverse("admin:event:schemes:configuration"))}
                className="btn btn-sm btn-dark"
            >
                <Awesome type="plus-circle" /> {t("Добавить")}
            </Button>
        </>
    );
    return (
        <DefaultLayout>
            {errors?.schema_not_empty && <Alert variant="danger">{errors.schema_not_empty}</Alert>}
            <ListingCard header={header} headerTools={headerTools}>
                <SchemaListSortable apiData={apiData} setApiData={setApiData} setErrors={setErrors} />
            </ListingCard>
        </DefaultLayout>
    );
}

function SchemaListSortable({ apiData, setApiData, setErrors }) {
    const { api_post } = useRequest();

    const handleDeleteSchema = (id) => {
        api_post(null, url_reverse("api:schema:list"), {
            params: { action: "delete_schema", schema_id: id },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                    setErrors({});
                } else if (resp.status === "fail") {
                    setErrors(resp.errors);
                }
            },
        });
    };

    const handleCloneSchema = (id) => {
        api_post(null, url_reverse("api:schema:list"), {
            params: { action: "clone_schema", schema_id: id },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                }
            },
        });
    };

    return (
        <DndTable
            apiData={apiData}
            setApiData={setApiData}
            apiUrl={url_reverse("api:schema:list")}
            tds={(el) => (
                <>
                    <td style={{ width: "30%" }}>
                        <Link to={`configuration/${el.id}`}>{el.name}</Link>
                    </td>
                    <td className={"dmg-table-row-tools"}>
                        <Button size="sm" variant="outline-primary" onClick={() => handleCloneSchema(el.id)}>
                            <Awesome type="clone" />
                        </Button>{" "}
                        <Button size="sm" variant="outline-danger" onClick={() => handleDeleteSchema(el.id)}>
                            <Awesome type="trash-o" />
                        </Button>
                    </td>
                </>
            )}
        />
    );
}
